import { CurrentTariff, PreviousTariff } from '@/types/marketplace'

/**
 * `beautyAutopilotOnly` — биллинг включён, тарифа нет, куплен только Beauty Autopilot: в проекте
 * доступен один виджет BA, остальное скрыто (страница проекта, маршруты).
 */
export type ProjectBillingStatus = 'open' | 'lock' | 'beforeTrial' | 'beautyAutopilotOnly'

export function getProjectBillingStatus(params: {
    billingEnabled: boolean
    billingBlock: boolean
    currentTariff?: CurrentTariff | null
    previousTariff?: PreviousTariff | null
    isTrialActivatedBefore: boolean
    beautyAutopilotEnabled?: boolean
}): ProjectBillingStatus {
    if (!params.billingEnabled) return 'open'
    if (params.billingBlock) return 'lock'
    if (params.currentTariff) return 'open'
    if (params.beautyAutopilotEnabled) return 'beautyAutopilotOnly'
    if (params.previousTariff) return 'lock'
    if (!params.isTrialActivatedBefore) return 'beforeTrial'
    return 'lock'
}

export function isBillingBlocked(status: ProjectBillingStatus): boolean {
    return status === 'lock'
}

export function isProjectContentAvailable(status: ProjectBillingStatus): boolean {
    return status === 'open' || status === 'beforeTrial'
}

export function isBeautyAutopilotOnlyStatus(status: ProjectBillingStatus): boolean {
    return status === 'beautyAutopilotOnly'
}
